import { authenticatedJsonFetch } from '@perpay-web/authentication/authenticatedJsonFetch';
import { HTTPMethod } from '@perpay-web/constants/httpMethods';
import { useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import { VIRTUAL_CARD_CREATE_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import {
    addToWallet,
    addToWalletError,
    addToWalletSuccess,
    addToWalletReset,
} from '@perpay-web/native-client/actions/nativeWallet';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';
import { emitOrTimeout } from '@perpay-web/utils/observable';

const useAddToWalletDataModule = () => {
    const dataModule = useDataModule(() =>
        emitOrTimeout(
            authenticatedJsonFetch(
                VIRTUAL_CARD_CREATE_ENDPOINT,
                {},
                HTTPMethod.post,
            ).catch(() =>
                Promise.reject(
                    new Error('Something went wrong, try again later.'),
                ),
            ),
        ),
    );

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: addToWallet,
        error: addToWalletError,
        success: addToWalletSuccess,
        reset: addToWalletReset,
    });

    return dataModule;
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useAddToWalletDataModule();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [UseAddToWalletDataModuleProvider, useAddToWalletContext] =
    createContextProvider(providerFactory);
